import { render } from "./SelectOffCat.vue?vue&type=template&id=3b35626b&scoped=true"
import script from "./SelectOffCat.vue?vue&type=script&lang=js"
export * from "./SelectOffCat.vue?vue&type=script&lang=js"

import "./SelectOffCat.vue?vue&type=style&index=0&id=3b35626b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b35626b"]])

export default __exports__